export default {
    add: { method: 'post', url: 'v1/movida/jira/add' },
    list: { method: 'post', url: 'v1/movida/profile/list' },
    listPerfisJira: { method: 'get', url: 'v1/movida/jira/list/{id}' }
}